module.exports = __webpack_public_path__ + "static/media/christmas-island.8db75796.svg";